import React from 'react'
import '../components/Sheet.css'
import './billing.css'

interface Props {
  // label names the group for assistive tech: the button that opened it.
  label: string
  // line is what today's charge is and what she pays after it.
  line: string
  confirm: string
  busy: boolean
  onConfirm: () => void
  onCancel: () => void
}

// ChargeConfirm is the ask before a change that charges her saved card today
// (going Pro from Payments, paying yearly), on the plan card and the Pro
// sheet alike (review, 2026-10-25): the line, then the confirm and the way
// back stacked full width like the app's other confirms. Focus moves to the
// confirm, since the button she pressed has gone.
export default function ChargeConfirm({ label, line, confirm, busy, onConfirm, onCancel }: Props) {
  const confirmRef = React.useRef<HTMLButtonElement>(null)
  React.useEffect(() => {
    confirmRef.current?.focus()
  }, [])
  return (
    <div className="charge-confirm" role="group" aria-label={label}>
      <p className="charge-confirm__line">{line}</p>
      <div className="sheet-stack">
        <button ref={confirmRef} type="button" className="btn btn-primary btn-block" onClick={onConfirm} disabled={busy}>
          {confirm}
        </button>
        <button type="button" className="btn btn-secondary btn-block" onClick={onCancel} disabled={busy}>
          Not now
        </button>
      </div>
    </div>
  )
}
